import { Navigate, Route } from 'react-router'
import { PATHS, SEGMENTS } from '@/app/router/routes'
import RoutesWithNotFound from '@/shared/components/routes-with-not-found'
import { FEATURES } from '@/shared/config/features'
import ForgotPassword from '../pages/forgot-password'
import { ForgotPasswordSuccess } from '../pages/forgot-password-success'
import { ForgotPasswordV2 } from '../pages/forgot-password-v2'
import Login from '../pages/login'
import { LoginV2 } from '../pages/login-v2'
import ResetPassword from '../pages/reset-password'
import { ResetPasswordV2 } from '../pages/reset-password-v2'
import TwoFactorAuth from '../pages/two-factor-auth'

export function AuthRouter() {
  return (
    <RoutesWithNotFound>
      <Route path="/" element={<Navigate to={SEGMENTS.auth.login} />} />
      <Route path={SEGMENTS.auth.login} element={FEATURES.webAuthV2 ? <LoginV2 /> : <Login />} />
      <Route
        path={SEGMENTS.auth.twoFactor}
        element={
          FEATURES.webAuthV2 ? <Navigate to={PATHS.auth.login} replace /> : <TwoFactorAuth />
        }
      />
      <Route
        path={SEGMENTS.auth.forgotPassword}
        element={FEATURES.webAuthV2 ? <ForgotPasswordV2 /> : <ForgotPassword />}
      />
      <Route path={SEGMENTS.auth.forgotPasswordSuccess} element={<ForgotPasswordSuccess />} />
      <Route path={SEGMENTS.auth.resetPasswordV2} element={<ResetPasswordV2 />} />
      <Route path={SEGMENTS.auth.resetPassword} element={<ResetPassword />} />
    </RoutesWithNotFound>
  )
}
